import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles, Typography } from '@material-ui/core';
import axios from 'axios';
import { red } from '@material-ui/core/colors';
import { Auth } from 'aws-amplify';
import LoaderButton from './LoaderButton';

const styles = {
    root: {
        marginTop: '20px',
        minHeight: '100px',
        marginBottom: '20px',
        padding: '0 10px 10px',
        textAlign: 'center'
    },
    card: {
        margin: '30px auto 0 auto',
        maxWidth: '360px',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: '4px',
        padding: '10px 0 10px 8px'
    },
    button: {
        margin: '40px 0 20px',
        width: '200px',
        height: '56px'
    },
    error: {
        margin: '20px 20px 10px',
        color: red[500],
        minHeight: '20px'
    }
};

class DirectDebitPaymentForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            processing: false,
            error: ''
        };
    }

    uploadImage = async () => {
        const { passenger } = this.props;

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_ENDPOINT}/customer-ticket/pre-signed-url`,
                {
                    fileType: passenger.photo.type,
                    fileSize: passenger.photo.size
                }
            );

            if (process.env.NODE_ENV !== 'development') {
                await axios.put(response.data.preSignedUrl, passenger.photo, {
                    headers: {
                        'Content-Type': passenger.photo.type
                    },
                    withCredentials: false,
                    transformRequest: v => v
                });
            }

            return response.data.fileName;
        } catch (error) {
            throw new Error(error);
        }
    };

    handleSubmit = async () => {
        const {
            history,
            ticket,
            service,
            passenger,
            client,
            voucher,
            disablePhoto
        } = this.props;
        this.setState({
            processing: true,
            error: ''
        });

        let imageFileName;
        let imageUploadError;

        if (!disablePhoto) {
            try {
                imageFileName = await this.uploadImage();
            } catch (e) {
                console.error(e);
                if (e.response) {
                    imageUploadError = {
                        type: 'response',
                        status: e.response.status,
                        data: e.response.data
                    };
                } else if (e.request) {
                    imageUploadError = {
                        type: 'request',
                        ready_state: e.request.readyState,
                        status: e.request.status,
                        timeout: e.request.timeout
                    };
                } else {
                    imageUploadError = {
                        type: 'unknown',
                        message: e.message
                    };
                }
            }
        }

        try {
            const currentSession = await Auth.currentSession();

            const headers = {
                Authorization: currentSession.getIdToken().getJwtToken()
            };

            const body = {
                ticket,
                service,
                passenger: {
                    ...passenger
                },
                client,
                voucher,
                ...(imageUploadError && {
                    skip_photo: true,
                    image_upload_error: imageUploadError
                })
            };

            if (!disablePhoto) {
                body.passenger.photo = imageFileName;
            }

            const response = await axios.post(
                `${process.env.REACT_APP_PAYMENT_API_ENDPOINT}/customer-ticket/gocardless`,
                body,
                {
                    headers
                }
            );

            if (response.data.id) {
                const ticketYear = ticket.year.replace('/', '-');
                const confirmUrl = `/order-confirmed/${response.data.id}/${ticketYear}/${client.slug}/${service.id}/${ticket.id}`;
                history.push(confirmUrl);
                // @NOTE: Hack to jump user to top of page on submit, as the route doesn't change
                // resulting in unexpected landing half way down subsequent view.
                window.scrollTo(0, 0);
            } else {
                throw new Error('No ticket id generated.');
            }
        } catch (e) {
            console.error(e);
            this.setState({
                processing: false,
                error:
                    'There was a problem processing your payment, please try again later'
            });
        }
    };

    render() {
        const { classes, client, service } = this.props;
        const { processing, error } = this.state;

        return (
            <div className={classes.root}>
                <Typography variant="body1" style={{ paddingBottom: '1em' }}>
                    By completing this purchase, I confirm I have read and
                    accepted the following:
                </Typography>
                {service.terms_url && (
                    <Typography variant="body1">
                        <a
                            href={service.terms_url}
                            rel="noopener noreferrer"
                            target="_blank"
                            style={{ color: '#000' }}
                        >
                            {client.name} T&amp;Cs
                        </a>
                    </Typography>
                )}
                <Typography variant="body1">
                    <a
                        href="https://shuttleid.uk/static/shuttleid-terms-of-use-passengers,-purchasers-and-other-users-updated-august-2020-8c80ca7b2c819e755e149871e5a98e88.pdf"
                        rel="noopener noreferrer"
                        target="_blank"
                        style={{ color: '#000' }}
                    >
                        ShuttleID T&amp;Cs
                    </a>
                </Typography>
                <LoaderButton
                    className={`${classes.button} pay-btn`}
                    variant="outlined"
                    color="primary"
                    type="submit"
                    isLoading={processing}
                    text="Confirm and pay"
                    loadingText="Confirming..."
                    onClick={this.handleSubmit}
                />
                {error && (
                    <Typography className={classes.error} variant="body2">
                        {error}
                    </Typography>
                )}
            </div>
        );
    }
}

DirectDebitPaymentForm.propTypes = {
    classes: PropTypes.shape().isRequired,
    ticket: PropTypes.shape().isRequired,
    service: PropTypes.shape().isRequired,
    passenger: PropTypes.shape().isRequired,
    client: PropTypes.shape().isRequired,
    disablePhoto: PropTypes.bool
};

DirectDebitPaymentForm.defaultProps = {
    disablePhoto: false
};

export default withStyles(styles)(withRouter(DirectDebitPaymentForm));
